/**
 * internal dependencies
 */
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { CUSTOMER_FORM } from '../form-customer-types';
import useAuth from '../../../../hooks/auth-hooks';
import DisplayCustomerInformation from './display-customer-info';
import DisplayCardGroupWidget from '../widgets/display-cg-widgets';
import { getParameters } from '../../../../helpers/helpers';
import { dropdown } from '../../../dropdown';

import { INewPartner } from '../../../../models/partner.interface';
import GetCustomerIndividual from '../../../../routes/get-customer-individual';
import GetPartners from '../../../../routes/get-partners';

/**
 * retireves data from AWS and calls funcs to do something with the data.
 * 
 * @returns void
 */
const GetIndividualCustomer = async () => {
  if ( !CUSTOMER_FORM.customerUpdateForm ) return;

  const userID = getParameters('userID');

  const [ customer, partner ] = await Promise.all([
    GetCustomerIndividual(userID),
    GetPartners()
  ]);

  const mapList = partner.body.map((value: INewPartner) => {
    return { id: value.partnerID, name: value.partnerName };
  });

  const { accessType, accessLevel } = useAuth()!;
  let hasAccess = true;
  if ( accessType === 'E' && accessLevel === 'P' ) {  
    hasAccess = false;
  }

  dropdown(mapList, 'partner', 'Partner', true, true, hasAccess);

  DisplayCustomerInformation(customer);
  DisplayCardGroupWidget(customer); 

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style'); 
}

export default GetIndividualCustomer;